import { css } from '@emotion/core';
import { useLocation } from 'react-router-dom';
import HeaderTab from './HeaderTab';
import useMessageService from '../../services/i18n/useMessageService';
import { AuthenticatedPaths } from '../../constants/Paths';

const HeaderTabList = () => {
    const { pathname } = useLocation();
    const [[homeLabel = 'Home', myAccountLabel = 'My Account']] = useMessageService([
        'home.home',
        'my_account.my_account',
    ]);

    return (
        <nav
            css={css`
                height: 100%;
            `}
        >
            <ul
                css={css`
                    display: flex;
                    margin: 0;
                    height: 100%;
                    gap: 2.3333rem;
                    padding: 0;
                `}
            >
                <HeaderTab
                    label={homeLabel}
                    path={AuthenticatedPaths.HOME}
                    selected={pathname.startsWith(AuthenticatedPaths.HOME)}
                />
                <HeaderTab
                    label={myAccountLabel}
                    path={AuthenticatedPaths.MY_ACCOUNT}
                    selected={pathname.startsWith(AuthenticatedPaths.MY_ACCOUNT)}
                />
            </ul>
        </nav>
    );
};
export default HeaderTabList;
